module.exports = __webpack_public_path__ + "static/media/box.333d2bfc.svg";